import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import fetchData from '../utils/fetchData';

export const getUserRole = async (userId) => {
    try {
        const userDoc = await getDoc(doc(db, 'users', userId));
        if (userDoc.exists()) {
            const userData = userDoc.data();
            return userData.isAdmin === true ? 'admin' : 'user';
        }

        //below is using new api but didnt test yet
        // const apiUrl = `${process.env.REACT_APP_API_BASE_URL}ai/writer/v1/user/firebase/${userId}`;
        // const response = await fetchData({
        //     url: apiUrl
        // });
        // console.log("response:", response);
        // //const userDoc = await getDoc(doc(db, 'users', userId));
        // if (response) {
        //     return response.isAdmin === true ? 'admin' : 'user';
        // }

        return 'user'; // Default to user if document doesn't exist
    } catch (error) {
        console.error('Error fetching user role:', error);
        return 'user'; // Default to user on error
    }
};